import React, {Component} from 'react';
import { Platform, Dimensions, View, Image, Text, StyleSheet, Keyboard,
         TouchableOpacity, TouchableHighlight, TouchableWithoutFeedback } from 'react-native';
import Icon from "react-native-vector-icons/Ionicons";
import MessageBox from "../ui/MessageBox";
import { Button, } from "native-base";
import { withTranslation } from "react-i18next";
import IsMobile from "../../utils/IsMobile";
import RoomClient from "../../utils/chinesepark/RoomClient";
import MediaConfig from '../../utils/chinesepark/MediaConfig';
import AVPermission from "../../utils/chinesepark/AVPermission";
import * as Helper from "../../utils/Helper";
import VideoView from "./VideoView";
//import FastImage from 'react-native-fast-image';
import UIDs from "../../UIDs";
import _ from 'lodash';

const uid = UIDs.screens.chinesepark.room;

class VideoPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isManager: RoomClient.getMyUser().isManager,
        };

        this.updateManager = this.updateManager.bind(this);
    }

    componentDidMount() {
        RoomClient.events.addListener("onUser", this.updateManager);
        RoomClient.events.addListener("onUsers", this.updateManager);
    }

    componentWillUnmount() {
        RoomClient.events.removeListener("onUser", this.updateManager);
        RoomClient.events.removeListener("onUsers", this.updateManager);
    }

    updateManager() {
        var user = RoomClient.getMyUser();
        if (this.state.isManager !== user.isManager) {
            this.setState({isManager: user.isManager});
        }
    }

    _handleSelectBook() {
        this.props.onSelectBook();
    }

    _handleLaunchPK() {
        this.props.onLaunchPK();
    }

    _handleAcceptPK(roleIndex) {
        this.props.onAcceptPK(roleIndex);
    }

    _handleStartPK() {
        this.props.onStartPK();
    }

    renderVideo(index, isPK, videoWidth, videoHeight, videoPerRow, lightMode) {
        return (<VideoView key={index} index={index}
                           mode={this.props.mode}
                           engine={this.props.engine}
                           videoWidth={videoWidth}
                           videoPerRow={videoPerRow}
                           lightMode={lightMode}
                           isPK={isPK} onNoRemainMinutes={this.props.onNoRemainMinutes}
                           roomInfo={this.props.roomInfo} isManager={this.state.isManager}
                           pkstate={isPK ? this.props.pkstate : {}}
                           pkinfo={isPK ? this.props.pkstate.dialogUsers[index] : {}}
                           mediaTest={this.props.mediaTest} onUserMenu={this.props.onUserMenu}
                           onLaunchPK={() => this._handleLaunchPK()}
                           onAcceptPK={(roleIndex) => this._handleAcceptPK(roleIndex)}
                           style={{width: videoWidth, height: videoHeight,
                                   paddingLeft: 0, paddingRight: 0}}/>);
    }

    renderVideoRow(index, count, width, height, isPK, isPC) {
        const videoWidth = isPC ? width : parseInt((width - StyleSheet.hairlineWidth * (count - 1)) / count);
        const videoHeight = height - 0;
        var videos = [];
        for (let i = 0; i < count; ++i) {
            videos.push(this.renderVideo(index + i, isPK, videoWidth, videoHeight, count,
                                         (isPC && (this.props.mode !== 'edu'))));
            if (i + 1 < count && (!isPC)) {
                videos.push((<View key={'line_' + index + i}
                                   style={{height: '100%', width: StyleSheet.hairlineWidth,
                                           backgroundColor: '#f0f0f0'}}/>));
            }
        }

        if (isPC) {
            return (<View style={{flexDirection: 'row', height: height, justifyContent: 'space-between'}}>
                        {videos}
                    </View>);
        }
        return (<View style={{flexDirection: 'row', height: height, backgroundColor: '#282828'}}>
                    {videos}
                </View>);
    }

    renderUserIcon(icon) {
        if (!icon) {
            return null;
        }
        if (icon.isUseAvatar) {
            return (<View style={{width: 32, height: 32, borderRadius: 5,
                                  alignItems: 'center', justifyContent: 'center',
                                  backgroundColor: icon.avatarBackgroundColor}}>
                    <Text style={{fontSize: 24, color: '#fff'}}>{icon.avatarName}</Text>
                    </View>);
        }
        return (<Image style={{width: 32, height: 32, borderRadius: 5}}
                resizeMode={'cover'}
                source={{uri: Helper.convertToAbsoluteUrl(icon.photo)}}/>);
    }

    renderPKToolBar() {
        var height = 54;
        var canLaunch = (this.props.roomInfo.ownerId === RoomClient.userid) || this.state.isManager || this.props.roomInfo.challengeType;
        var color = canLaunch ? '#157efb' : '#a0a0a0';
        if (this.props.pkstate.state === RoomClient.PK_STATE_INIT) {
            return (<View style={{height: height, backgroundColor: '#434749',
                                  alignItems: 'center', justifyContent: 'center'}}>
                    <Button transparent style={{height: 36, borderWidth: 1,
                                                width: '90%', paddingTop: 0, paddingBottom: 0,
                                                borderColor: color, borderRadius: 20,
                                                backgroundColor: color,
                                                alignItems: 'center', justifyContent: 'center'}}
                    disabled={!canLaunch} onPress={() => this._handleLaunchPK()}>
                    <Text style={{ fontSize: 16, color:"#fff"}}>{this.props.t("launchPK")}</Text>
                    </Button>
                    </View>);
        }

        /*
        if (this.props.pkstate.state === RoomClient.PK_STATE_READY && (this.props.pkstate.cdown < 0)) {
            if (RoomClient.isPKMyLauncher() || RoomClient.getPKMyRole() >= 0) {
                return (<View style={{height: height, backgroundColor: '#434749',
                                      alignItems: 'center', justifyContent: 'center'}}>
                            <Button transparent style={{height: 36, borderWidth: 1,
                                                        width: '90%', paddingTop: 0, paddingBottom: 0,
                                                        borderColor: '#157efb', borderRadius: 20,
                                                        backgroundColor: '#157efb',
                                                        alignItems: 'center', justifyContent: 'center'}}
                                    onPress={() => this._handleStartPK()}>
                                <Text style={{ fontSize: 16, color:"#fff"}}>{this.props.t("startPK")}</Text>
                            </Button>
                        </View>);
            }
        }
        */

        var canAccept = (RoomClient.getPKMyRole() === -1);
        var color = canAccept ? '#157efb' : '#a0a0a0';
        const screenWidth = Dimensions.get("window").width;
        const maxTitleWidth = screenWidth * 90 / 100 - 40;
        if (this.props.pkstate.state === RoomClient.PK_STATE_WAIT) {
            const { title } = this.props.pkstate.subject || {};
            return (<View style={{height: height, backgroundColor: '#434749',
                                  alignItems: 'center', justifyContent: 'center'}}>
                    <Button transparent style={{height: 36, borderWidth: 1,
                                                width: '90%', paddingTop: 0, paddingBottom: 0,
                                                borderColor: color, borderRadius: 20,
                                                backgroundColor: color,
                                                alignItems: 'center', justifyContent: 'center'}}
                    disabled={!canAccept} onPress={() => this._handleAcceptPK(-1)}>
                        <Text numberOfLines={1} ellipsizeMode={'tail'}
                              style={{ fontSize: 16, color:"#fff", maxWidth: maxTitleWidth}}>
                            {title ? this.props.t("acceptPK({{book}})", {book: title}) : this.props.t("acceptPK")}
                        </Text>
                    </Button>
                    </View>);
        }

        const maxNameWidth = (screenWidth - (40 + 4 + 8) * 2 - 30) / 2;
        return (<View style={{height: height, backgroundColor: '#434749',
                              alignItems: 'center', justifyContent: 'center'}}>
                <View style={{flexDirection: 'row', alignItems: 'center'}}>
                <View style={{flex: 1, flexDirection: 'row',
                              alignItems: 'center', justifyContent: 'center'}}>
                {this.renderUserIcon(this.props.pkstate.dialogUsers[0].icon)}
                <Text numberOfLines={1} ellipsizeMode={'tail'} style={{marginLeft: 8, maxWidth: maxNameWidth, fontSize: 16, color: '#fff'}}>{this.props.pkstate.dialogUsers[0].name}</Text>
                </View>
                <View style={{position: 'absolute', left: 0, top: 0, right: 0, bottom: 0,
                              alignItems: 'center', justifyContent: 'center'}}>
                <Text style={{fontSize: 22, color: '#f9ab00'}}>VS</Text>
                </View>
                <View style={{flex: 1, flexDirection: 'row',
                              alignItems: 'center', justifyContent: 'center'}}>
                <Text numberOfLines={1} ellipsizeMode={'tail'} style={{textAlign: 'right', marginRight: 8, maxWidth: maxNameWidth, fontSize: 16, color: '#fff'}}>{this.props.pkstate.dialogUsers[1].name}</Text>
                {this.renderUserIcon(this.props.pkstate.dialogUsers[1].icon)}
                </View>
                </View>
                </View>);
    }

    renderStartPK() {
        /*
        if (this.props.pkstate.state === RoomClient.PK_STATE_READY && (this.props.pkstate.cdown < 0)) {
            if (RoomClient.isPKMyLauncher() || RoomClient.getPKMyRole() >= 0) {
                return (<View style={{position: 'absolute', left: 0, top: 0, right: 0, bottom: 0,
                                      zIndex: 10, alignItems: 'center', justifyContent: 'center'}}>
                            <Button transparent onPress={() => this._handleStartPK()}
                                    style={{height: 36, borderWidth: 1,
                                            paddingTop: 0, paddingBottom: 0,
                                            paddingLeft: 30, paddingRight: 30,
                                            borderColor: '#00c259', borderRadius: 18,
                                            backgroundColor: '#00c259',
                                            elevation: 20,
                                            shadowColor: "#000",
                                            shadowOffset: { width: 4, height: 4 },
                                            shadowOpacity: 0.2,
                                            shadowRadius: 4,
                                            alignItems: 'center', justifyContent: 'center'}}>
                                <Text style={{ fontSize: 16, color:"#fff"}}>{this.props.t("startPK")}</Text>
                            </Button>
                        </View>);
            }
        }
        */
        return null;
    }

    renderMobile() {
        const screenWidth = Dimensions.get("window").width;
        const screenHeight = Dimensions.get("window").height;
        const isPK = (this.props.mode === 'pk');
        const isEdu = (this.props.mode === 'edu');
        var rowCount =  isPK ? 1 : 3;
        var videoPerRow = 2;
        var totalHeight = 0;
        if (IsMobile()) {
            if (isPK) {
                totalHeight = parseInt(screenWidth * 120 / 360);
                //totalHeight += 28;
                totalHeight += 10;
            }
            else if (isEdu) {
                totalHeight = parseInt(screenWidth * 200 / 260);
            }
            else {
                totalHeight = parseInt(screenWidth * 240 / 260);
            }

            if (isPK) {
                const pkPersons = RoomClient.getPKPersons();
                if (pkPersons > 3) {
                    rowCount =  2;
                    videoPerRow = 3;
                    totalHeight = parseInt(screenWidth / 3 * 20 / 32 * 2);
                }
                else if (pkPersons > 2) {
                    rowCount =  1;
                    videoPerRow = 3;
                    totalHeight = parseInt(screenWidth / 3 * 3 / 4);
                }
            }
        }
        else {
            if (isPK) {
                totalHeight = 64;
                //totalHeight += 28;
                totalHeight += 10;
            }
            else if (isEdu) {
                totalHeight = 300;
            }
            else {
                totalHeight = 220;
            }

            if (isPK) {
                const pkPersons = RoomClient.getPKPersons();
                if (pkPersons > 3) {
                    rowCount =  2;
                    videoPerRow = 3;
                    totalHeight = 128;
                }
                else if (pkPersons > 2) {
                    rowCount =  1;
                    videoPerRow = 3;
                    totalHeight = 64;
                }
            }
        }

        var rowHeight = parseInt(totalHeight / rowCount);
        //var barHeight = isPK ? 54 : 0;
        var barHeight = 0;

        if (isPK && this.props.pkstate.state === RoomClient.PK_STATE_INIT) {
            return (<TouchableWithoutFeedback style={{flex:1}} onPress={() => Keyboard.dismiss()}>
                        <View style={{flexDirection: 'column', width: screenWidth, height: totalHeight,
                                      alignItems: 'center', justifyContent: 'center'}}>
                            <TouchableOpacity onPress={() => this._handleSelectBook()}>
                                <View style={{flexDirection: 'row', alignItems: 'center',
                                              paddingLeft: 30, paddingRight: 30,
                                              paddingTop: 10, paddingBottom: 10,
                                              borderRadius: 6, backgroundColor: '#156ed6'}}>
                                    <Icon name="ios-add" style={{ fontSize: 16, color: "#fff", marginRight: 4 }} />
                                    <Text style={{color: '#fff'}}>{this.props.t('choosePKDialog')}</Text>
                                </View>
                            </TouchableOpacity>
                        </View>
                    </TouchableWithoutFeedback>);
        }
        return (<TouchableWithoutFeedback style={{flex:1}} onPress={() => Keyboard.dismiss()}>
                <View style={{flexDirection: 'column', width: screenWidth,
                              height: totalHeight + barHeight + 0}}>
                    <View style={{flexDirection: 'column', backgroundColor: '#282828', paddingBottom: 0}}>
                        {this.renderVideoRow(0, videoPerRow, screenWidth, rowHeight, isPK)}
                        {(rowCount > 1) ? (<View style={{height: StyleSheet.hairlineWidth, backgroundColor: '#f0f0f0'}}/>) : null}
                        {(rowCount > 1) ? this.renderVideoRow(videoPerRow, videoPerRow, screenWidth, rowHeight, isPK) : null}
                        {(rowCount > 2) ? (<View style={{height: StyleSheet.hairlineWidth, backgroundColor: '#f0f0f0'}}/>) : null}
                        {(rowCount > 2) ? this.renderVideoRow(videoPerRow * 2, videoPerRow, screenWidth, rowHeight, isPK) : null}
                    </View>
                    {/*isPK ? this.renderPKToolBar() : null*/}
                    {isPK ? this.renderStartPK() : null}
                </View>
                </TouchableWithoutFeedback>
        );
    }

    renderPC() {
        const isPK = (this.props.mode === 'pk');
        const isEdu = (this.props.mode === 'edu');
        var rowCount = 2;
        if (isPK) {
            rowCount = 1;
        }

        if (isEdu) {
            rowCount = 3;
        }

        var videoPerRow = 3;
        if (isEdu) {
            videoPerRow = 2;
        }

        var totalHeight = 0;
        var videoWidth = 180;
        var hspace = 20;
        var vspace = 20;
        if (isPK) {
            const pkPersons = RoomClient.getPKPersons();
            rowCount = 1;
            videoPerRow = pkPersons;
            if (videoPerRow < 2) {
                videoPerRow = 2;
            }
            videoWidth = 160;
            totalHeight = 120;
            if (pkPersons > 3) {
                videoPerRow = 3;
                rowCount = 2;
                totalHeight = 240;
            }
        }
        else if (isEdu) {
            videoWidth = 122;
            totalHeight = 300;
            hspace = 12;
            vspace = 8;
        }
        else {
            totalHeight = 340;
        }

        var rowHeight = parseInt(totalHeight / rowCount);
        //var barHeight = isPK ? 54 : 0;
        var barHeight = 0;
        var panelWidth = videoWidth * videoPerRow + hspace * (videoPerRow - 1);
        var panelHeight = totalHeight + vspace * (rowCount - 1);
        if (isPK && this.props.pkstate.state === RoomClient.PK_STATE_INIT) {
            return (<View style={{width: panelWidth, height: panelHeight,
                                 alignItems: 'center', justifyContent: 'center'}}>
                        <View style={{flexDirection: 'column', alignItems: 'center',
                                      justifyContent: 'center'}}>
                            <TouchableOpacity onPress={() => this._handleSelectBook()}>
                                <View style={{flexDirection: 'row', alignItems: 'center',
                                              paddingLeft: 30, paddingRight: 30,
                                              paddingTop: 10, paddingBottom: 10,
                                              borderRadius: 6, backgroundColor: '#156ed6'}}>
                                    <Icon name="ios-add" style={{ fontSize: 16, color: "#fff", marginRight: 4 }} />
                                    <Text style={{color: '#fff'}}>{this.props.t('choosePKDialog')}</Text>
                                </View>
                            </TouchableOpacity>
                        </View>
                    </View>);
        }
        return (<View style={{width: panelWidth}}>
                    <View style={{flexDirection: 'column', justifyContent: 'space-between',
                                  height: panelHeight, paddingBottom: 0}}>
                        {this.renderVideoRow(0, videoPerRow, videoWidth, rowHeight, isPK, true)}
                        {(rowCount > 1) ? this.renderVideoRow(videoPerRow, videoPerRow, videoWidth, rowHeight, isPK, true) : null}
                        {(rowCount > 2) ? this.renderVideoRow(videoPerRow * 2, videoPerRow, videoWidth, rowHeight, isPK, true) : null}
                    </View>
                    {/*isPK ? this.renderPKToolBar() : null*/}
                    {isPK ? this.renderStartPK() : null}
                </View>
        );
    }

    render() {
        if (IsMobile()) {
            return this.renderMobile();
        }
        return this.renderPC();
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});

export default withTranslation(uid, { withRef: true })(VideoPanel);
